import React from 'react'
import { connect } from 'react-redux'
import LoginRequired from './LoginRequired'
import { isDevAuthBypassEnabled } from './authConfig'

const mapStateToProps = state => ({
    access_token: state.access_token,
    username: state.username,
})

const requireLogin = Component =>
    connect(mapStateToProps)(
        props => (isDevAuthBypassEnabled() || props.access_token)
            ? <Component {...props} />
            : <LoginRequired />
    )



export default requireLogin